import CommonProducts from '../components/common-products';
import { useLang } from '@/app/utils/useLang';

const EnergyStorage: React.FC = () => {
    const { t } = useLang('landingPage.energy_storage');
    const items = [
        {
            img: '',
            label: t('item1_title'),
            productId: '8006700236954',
            variantId: '51984499736947',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
        },
        {
            img: '',
            label: t('item2_title'),
            productId: '8231518666906',
            variantId: '44902577209498',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-3-extra-battery?variant=44902577209498',
        },
        {
            img: '',
            label: t('item3_title'),
            productId: '7285229682842',
            variantId: '43725966016666',
            learnMore: 'https://ca.ecoflow.com/products/delta-pro-smart-extra-battery?variant=43725966016666',
        },
    ];

    return (
        <div>
            <CommonProducts items={items} title={t('title')} />
        </div>
    );
};

export default EnergyStorage;
